import { useEffect, useState } from 'react';
import StaffNavbar from '../components/StaffNavbar';
import EmbedApiKeySection from '../components/EmbedApiKeySection';
import apiService from '../services/api';

const StaffSettings = () => {
  const [user, setUser] = useState(apiService.getCurrentUser());
  const [loading, setLoading] = useState(true);

  const schoolId = user?.active_school?.id || '';

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      try {
        const freshUser = await apiService.fetchCurrentUser();
        if (!cancelled) {
          setUser(freshUser);
        }
      } catch (err) {
        console.error('Failed to load settings user:', err);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="admin-dashboard">
      <StaffNavbar activeSection="settings" />
      <div className="admin-main">
        <div className="admin-content">
          <h1>Settings</h1>
          <p>Configure your school's settings and preferences.</p>

          {loading ? (
            <p style={{ color: '#64748b', marginTop: '32px' }}>Loading integration settings...</p>
          ) : (
            <EmbedApiKeySection schoolId={schoolId} />
          )}


        </div>
      </div>
    </div>
  );
};

export default StaffSettings;
